export enum ChatEntryPoint {
	JSM_ROVO_SETTINGS_TEST_NOW = 'jsmRovoSettingsTestNow',
	JSM_PORTAL_SETTINGS_TEST_NOW = 'jsmPortalSettingsTestNow',
	SEARCH_PAGE_AUTO_OPEN_CHAT = 'searchPageAutoOpenChat',
	SEARCH_PAGE_SUMMARIZE_IN_CHAT = 'searchPageSummarizeInChat',
}
